import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1976d2', // Vuetify default color
        secondary: '#424242', // Vuetify default color
        accent: '#82b1ff', // Vuetify default color
        success: '#28a745', // Bootstrap default
        info: '#2196f3', // Vuetify default color
        error: '#ff5252',
        warning: '#fb8c00',
      },
    },
  },
})
